import { render, staticRenderFns } from "./AddCovidVaccine.vue?vue&type=template&id=6f10d962&scoped=true&"
import script from "./AddCovidVaccine.vue?vue&type=script&lang=js&"
export * from "./AddCovidVaccine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10d962",
  null
  
)

export default component.exports